import { createContext, useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { translations } from "./translations";
import { initAnalytics, trackPageView } from "../analytics";

const LanguageContext = createContext(null);

const STORAGE_KEY = "uba-language";

export const LanguageProvider = ({ children, forcedLang, docTitle }) => {
  const navigate = useNavigate();
  const [language, setLanguageState] = useState(() =>
    forcedLang && translations[forcedLang] ? forcedLang : "ro"
  );

  useEffect(() => {
    if (forcedLang && translations[forcedLang]) {
      setLanguageState(forcedLang);
    }
  }, [forcedLang]);

  useEffect(() => {
    window.localStorage.setItem(STORAGE_KEY, language);
    document.documentElement.lang = language;
    document.title = docTitle || translations[language].docTitle;
    const siteUrl = process.env.REACT_APP_SITE_URL;
    const canonical = document.querySelector('link[rel="canonical"]');
    if (canonical && siteUrl) {
      canonical.setAttribute(
        "href",
        language === "ro" ? `${siteUrl}/` : `${siteUrl}/${language}`
      );
    }
    initAnalytics();
    trackPageView(language);
  }, [language, docTitle]);

  const setLanguage = (lang) => {
    if (!translations[lang]) return;
    setLanguageState(lang);
    navigate(lang === "ro" ? "/" : `/${lang}`);
  };

  const t = translations[language];

  return (
    <LanguageContext.Provider value={{ language, setLanguage, t }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error("useLanguage must be used within LanguageProvider");
  return ctx;
};
